import React from "react";
import { formatDate } from "../../../utils/commonFunctions";
import { CircularAvatar } from "../../commons";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { CalenderIcon } from "../../Icon";
import { CalanderGrayIcon, ClockIcon } from "../../../assets/images";
type AppProps = {
  header: any;
  data: any;
  update: any;
};
const statusApprovalPendingTypeStyle = () => {
  return {
    padding: "4px 13px 4px 13px",
    color: "#f3a119",
    background: "#faedd8",
    borderRadius: "16px",
    width: "20px",
  };
};

const statusReEstimateTypeStyle = () => {
  return {
    padding: "4px 13px 4px 13px",
    color: "#2d8589",
    background: "#d4edf0",
    borderRadius: "16px",
    width: "20px",
  };
};

const statusUnScheduledTypeStyle = () => {
  return {
    padding: "4px 13px 4px 13px",
    color: "#262a44",
    background: "#e2e4ed",
    borderRadius: "16px",
    width: "20px",
  };
};
const blank = () => {
  return {};
};
const UserJobSummery = ({ header, data, update }: AppProps) => {
  return (
    <div style={{ border: "1px solid #bfcbe1", padding: "20px" }}>
      <div style={{ fontSize: "16px", fontWeight: "500" }}> Job Summary</div>

      <div
        className="mt-2"
        style={{
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        {header.map((el: any) => {
          if (el === "jobIdType") {
            return (
              <div>
                <div
                  style={{
                    color: "#bfcbe1",
                    fontWeight: "500",
                    fontSize: "13px",
                  }}
                >
                  {" "}
                  Job Type & ID
                </div>

                <div>
                  {(data?.job_id ? `${data?.job_id}_` : "") +
                    data?.job_type +
                    `_` +
                    formatDate(data?.period_ended)}
                </div>
              </div>
            );
          } else if (el === "description") {
            return (
              <div style={{ maxWidth: "300px" }}>
                <span
                  style={{
                    color: "#bfcbe1",
                    fontWeight: "500",
                    fontSize: "13px",
                  }}
                >
                  Details
                </span>

                <div>
                  {data?.job_description?.length > 25 ? (
                    <OverlayTrigger
                      placement="bottom"
                      delay={{ show: 250, hide: 250 }}
                      overlay={
                        <Tooltip id="button-view">
                          {data?.job_description}
                        </Tooltip>
                      }
                    >
                      <span>
                        {data?.job_description.toLowerCase()?.substr(0, 25) +
                          (data?.job_description &&
                          data?.job_description?.length > 20
                            ? "..."
                            : "")}
                      </span>
                    </OverlayTrigger>
                  ) : (
                    data?.job_description
                  )}
                </div>
              </div>
            );
          } else if (
            el === "client" &&
            (data?.schedule_status === 3 || update)
          ) {
            return (
              <div>
                <span
                  style={{
                    color: "#bfcbe1",
                    fontWeight: "500",
                    fontSize: "13px",
                  }}
                >
                  Client Name
                </span>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  {`${data?.client_name} (${data?.client_code})`}
                </div>
              </div>
            );
          } else if (el === "estimateBy") {
            return (
              <div>
                <span
                  style={{
                    color: "#bfcbe1",
                    fontWeight: "500",
                    fontSize: "13px",
                  }}
                >
                  Estimated By
                </span>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <div>
                    <CircularAvatar
                      name={data?.created_by?.name}
                      image={
                        data?.created_by?.profile_pic?.file_url &&
                        data?.created_by?.profile_pic?.file_url
                      }
                    />
                  </div>
                  <div className="ml-2">
                    {data?.created_by?.name}
                    {/* <div>{data?.created_by?.job_title}</div> */}
                    <div
                      style={{
                        fontSize: "12px",
                        fontWeight: 500,
                        color: "#6e7491",
                      }}
                    >
                      {`${
                        data?.created_by?.job_title
                          ? data?.created_by?.job_title
                          : ""
                      }${data?.created_by?.department ? "," : ""} ${
                        data?.created_by?.department
                          ? data?.created_by?.department
                          : ""
                      }`}
                    </div>
                  </div>
                </div>
              </div>
            );
          } else if (el === "startDate") {
            return (
              <div>
                <span
                  style={{
                    color: "#bfcbe1",
                    fontWeight: "500",
                    fontSize: "13px",
                  }}
                >
                  Start Date
                </span>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  {data?.target_start_date ? (
                    <img src={CalanderGrayIcon} alt="cal" className="mr-1" />
                  ) : (
                    ""
                  )}
                  <div>
                    {data?.target_start_date
                      ? formatDate(data?.target_start_date)
                      : "--/--"}
                  </div>
                </div>
              </div>
            );
          } else if (el === "targetEndDate") {
            return (
              <div>
                <span
                  style={{
                    color: "#bfcbe1",
                    fontWeight: "500",
                    fontSize: "13px",
                  }}
                >
                  {" "}
                  Target End Date
                </span>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  {data?.target_end_date ? (
                    <img src={CalanderGrayIcon} alt="cal" className="mr-1" />
                  ) : (
                    ""
                  )}
                  <div>
                    {data?.target_end_date
                      ? formatDate(data?.target_end_date)
                      : "--/--"}
                  </div>
                </div>
              </div>
            );
          } else if (el === "scheduleStatus") {
            return (
              <div>
                <span
                  style={{
                    color: "#bfcbe1",
                    fontWeight: "500",
                    fontSize: "13px",
                  }}
                >
                  Schedule Status
                </span>

                <div>
                  <span
                    style={
                      data?.schedule_status === 1
                        ? statusApprovalPendingTypeStyle()
                        : data?.schedule_status === 2
                        ? statusReEstimateTypeStyle()
                        : data?.schedule_status === 0
                        ? statusUnScheduledTypeStyle()
                        : blank()
                    }
                  >
                    {data?.schedule_status === 1
                      ? "Approval Pending"
                      : data?.schedule_status === 2
                      ? "Re-Estimate"
                      : data?.schedule_status === 3
                      ? "Approved"
                      : data?.schedule_status === 0
                      ? "Unscheduled"
                      : ""}
                  </span>
                </div>
              </div>
            );
          } else if (el === "totalHours") {
            return (
              <div>
                <span
                  style={{
                    color: "#bfcbe1",
                    fontWeight: "500",
                    fontSize: "13px",
                  }}
                >
                  Total Hours
                </span>

                <div style={{ display: "flex", alignItems: "center" }}>
                  <img src={ClockIcon} alt="cal" className="mr-1" />
                  {data?.total_hours} hours
                </div>
              </div>
            );
          }

          if (data?.total_hours && !update) {
            if (el === "PreviousEstimation") {
              return (
                <div>
                  <span
                    style={{
                      color: "#bfcbe1",
                      fontWeight: "500",
                      fontSize: "13px",
                    }}
                  >
                    Previous Estimation
                  </span>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <img src={ClockIcon} alt="cal" className="mr-1" />
                    <div>
                      {data?.total_hours ? data?.total_hours : "--/--"} hours
                    </div>
                  </div>
                </div>
              );
            }
          }
        })}
      </div>
    </div>
  );
};

export default UserJobSummery;
